import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/aliases/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ALIASES }) &&
      context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
